<template>
  <div id="initDoc">
    <!-- STEP 1 -->

    <v-container v-show="employee.active" id="scan-emp-panel" fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md4 text-lg-center text-xs-center>
          <v-icon color="orange darken-1" style="font-size: 110px">account_box</v-icon>
          <v-text-field
            ref="employee"
            key="emp"
            label="รหัสพนักงาน"
            :append-icon="employee.input ? 'send' : ''"
            outline
            single-line
            clearable
            :error-messages="employee.errorMessage"
            v-model="employee.input"
            @click:append="employeeEnterScan"
            @keyup.enter="employeeEnterScan "
          ></v-text-field>
          <v-btn color="warning" large @click="employeeEnterScan">Next</v-btn>
        </v-flex>
      </v-layout>
      <!-- <v-flex v-show="!employee.showAction">
        <div class="text-xs-center">
          <div>{{ empCode }}</div>
          <div class="display-1">
            {{ empName }}
            <v-btn fab dark small color="error" title="ล้างรายการ" @click="clearAll">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-flex>-->
    </v-container>

    <!-- STEP 2 -->
    <v-container fluid v-show="doc.active">
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md4 text-xs-center>
          <v-icon color="green darken-1" style="font-size: 110px">assignment</v-icon>
          <v-text-field
            ref="doc"
            label="เลขที่เอกสารขายสินค้า"
            :append-icon="doc.input ? 'send' : ''"
            outline
            single-line
            clearable
            :error-messages="doc.errorMessage"
            v-model="doc.input"
            @click:append="docEnterScan"
            @keyup.enter="docEnterScan "
          ></v-text-field>
          <div>
            <v-btn color="error" large @click="clearAll">Cancel</v-btn>
            <v-btn color="success" large @click="docEnterScan">Next</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid v-show="doc.active">
      <v-flex v-show="doc.showAction" xs12 md4 offset-md4></v-flex>
      <v-flex v-show="!doc.showAction">
        <div class="text-xs-center display-1">
          {{ docNo }} : {{ docInfo }}
          <v-btn fab dark small color="error" title="ล้างรายการ" @click="clearAll">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="text-xs-center">{{ shipment_to }}</div>
        <div class="text-xs-center">{{ docAddress }}</div>
      </v-flex>
    </v-container>

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">มีการจัดสินค้าไปแล้ว</v-card-title>
        <v-card-text>{{ doc.input }}</v-card-text>
        <v-card-text>ต้องการดำเนินการแก้ไขหรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="confirmCencelEditParcel">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="confirmEditParcel">แก้ไข</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errorPickDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">มีการนำไปจัดส่งแล้ว</v-card-title>
        <v-card-text>{{ doc.input }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="errorPickDialog = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- STEP3 -->
    <v-container fluid v-show="!pack.displayDisable" row warp>
      <v-layout>
        <v-flex sm9>
          <v-container fluid>
            <v-layout row>
              <v-flex xs2>
                <div class="title pt-3">จำนวนกล่อง:</div>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  ref="sumParcel"
                  label="จำนวนกล่อง/หีบ"
                  append-outer-icon="send"
                  outline
                  single-line
                  clearable
                  :error-messages="sumParcel.errorMessage"
                  v-model="sumParcel.count"
                  @click:append-outer="submitParcel"
                  @keyup.enter="submitParcel"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 offset-xs2 text-xs-right>
                <v-btn rounded color="error" title="ยกเลิก" @click="clearAll">
                  <v-icon left>cancel</v-icon>ยกเลิก
                </v-btn>
                <v-btn rounded color="success" title="บันทึก/ส่งพิมพ์" @click="savePackingHandle">
                  <v-icon left>save</v-icon>บันทึก/ส่งพิมพ์
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex sm12>
                <div class="headline">กล่อง/หีบห่อ สินค้า</div>
                <div
                  class="grey--text text--darken-1 mb-1"
                >ทั้งหมด {{ parcels.length }} กล่อง | ค้างบรรจุสินค้า {{ balanceTotalItem }} รายการ {{ balanceTotalItemQty }} ชิ้น</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 v-for="(parcel, index) in parcels" :key="parcel.id">
                <v-card class="mt-3">
                  <v-card-title>
                    <v-icon large left>drafts</v-icon>
                    <span class="title font-weight-light">{{ parcel.id }}</span>

                    <v-spacer></v-spacer>
                    <v-btn icon @click="parcel.show_detail = !parcel.show_detail">
                      <v-icon>{{ parcel.show_detail ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-slide-y-transition>
                    <v-card-text v-show="parcel.show_detail">
                      <v-container pa-0>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="title">กล่อง {{ parcel.name }}</div>
                          </v-flex>
                          <v-flex xs12 md6 align-self-center>
                            <div class="pl-3">
                              <span
                                class="headline pr-3"
                              >จำนวนทั้งหมด {{ parcel.items.length }} รายการ</span>
                              <span
                                class="subheading grey--text"
                              >{{ parcel.items | itemTotalQty }} ชิ้น</span>
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 class="text-sm-right">
                            <v-btn flat color="error" @click="handleParcelDelete(parcel.id)">
                              <v-icon color="error" title="ลบ">delete</v-icon>
                              <!-- ลบ -->
                            </v-btn>
                            <v-btn flat color="orange" @click="enterParcel(index)">
                              <v-icon color="orange" title="จัดการสินค้า">edit</v-icon>
                              <!-- จัดการสินค้า -->
                            </v-btn>
                            <v-btn
                              flat
                              color="green"
                              @click="showParcelDetail(parcel.name, parcel.items)"
                            >
                              <v-icon color="green" title="รายละเอียดสินค้า">visibility</v-icon>
                              <!-- รายละเอียดสินค้า -->
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-slide-y-transition>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <!-- <v-flex v-show="this.parcels.length > 0" xs12 class="text-xs-center" mt-3>
            <v-btn fab dark large color="success" title="บันทึก" @click="savePackingHandle">
              <v-icon>save</v-icon>
            </v-btn>
          </v-flex>
          <v-flex v-show="this.parcels.length > 0" xs12 class="text-xs-center">บันทึก/ส่งพิมพ์</v-flex>-->
        </v-flex>
        <v-flex sm3>
          <v-card class="mb-4">
            <v-card-title layout row ma-0 justify-space-between pb-1>
              <div class="headline">Invoices</div>
              <v-spacer></v-spacer>
              <div class="icon">
                <v-icon color="blue lighten-2">assignment</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row>
                <v-flex>
                  <v-text-field label="Add More Invoice" outline single-line clearable v-model="doc_ref_add"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-btn large color="warning" title="เพิ่ม" @click="addInvoice">
                    <v-icon left>add_circle_outline</v-icon>เพิ่ม
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text>
              <v-chip v-for="(doc_ref_no, index) in doc_ref" :key="index"
                close
                @input="remove_doc_ref(index)"
                >{{doc_ref_no}}
                </v-chip>
            </v-card-text>
          </v-card>

          <v-dialog v-model="addinvoicedialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">มีการจัดสินค้าไปแล้ว</v-card-title>
              <v-card-text>{{ last_add_invoice }}</v-card-text>
              <v-card-actions>                
                <v-spacer></v-spacer>
                <v-btn color="warning" @click="addinvoicedialog = false">ปิด</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card class="mb-4">
            <v-card-title layout row ma-0 justify-space-between pb-1>
              <div class="headline">ลูกค้า</div>
              <v-spacer></v-spacer>
              <div class="icon">
                <v-icon color="red darken-4">airport_shuttle</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              ผู้รับ: {{ shipment_to }}
              <br />
              ที่อยู่: {{ docAddress }}
            </v-card-text>
          </v-card>

          <v-card class="mb-4">
            <v-card-title layout row ma-0 justify-space-between pb-1>
              <div class="headline">พนักงาน</div>
              <v-spacer></v-spacer>
              <div class="icon">
                <v-icon color="teal darken-1">account_circle</v-icon>
              </div>
            </v-card-title>
            <v-card-text>{{ empName }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-flex v-show="this.parcels.length == 0" xs12 md4 offset-md4></v-flex>

      <!-- <v-flex v-show="this.parcels.length > 0" xs12 class="text-xs-center" mt-3>
            <v-btn fab dark large color="success" title="พิมพ์" @click="parcelLabelPrint">
              <v-icon>print</v-icon>
            </v-btn>
      </v-flex>-->
      <!-- <v-flex v-show="this.parcels.length > 0"  xs12 class="text-xs-center" mt-3>           
            <v-btn fab dark large color="primary" title="เพิ่มกล่องบรรจุ" @click="openAddParcel">
              <v-icon>add</v-icon>
            </v-btn>
            </v-flex>
          
      <v-flex v-show="this.parcels.length > 0" xs12 class="text-xs-center">เพิ่มกล่องบรรจุ</v-flex>-->
    </v-container>

    <v-container fluid v-if="!activeParcel">
      <!-- <v-layout row wrap>
        <v-flex xs12>
          <div :class="employee.active ? 'black--text': 'grey--text'">
            <v-chip
              :selected="false"
              :outline="employee.active ? false: true"
              :color="employee.active ? 'primary': 'grey'"
              :text-color="employee.active ? 'white' : 'grey'"
            >1</v-chip>สแกนรหัสพนักงาน
          </div>
        </v-flex>
      </v-layout>-->
      <!-- <v-layout row wrap>
        <v-flex xs12>
          <div :class="doc.active ? 'black--text': 'grey--text'">
            <v-chip
              :selected="false"
              :outline="doc.active ? false: true"
              :color="doc.active ? 'primary': 'grey'"
              :text-color="doc.active ? 'white' : 'grey'"
            >2</v-chip>สแกนเอกสารขายสินค้า
          </div>
        </v-flex>        
      </v-layout>-->
      <!-- <v-layout row wrap>
        <v-flex xs12>
          <div :class="pack.active ? 'black--text': 'grey--text'">
            <v-chip
              :selected="false"
              :outline="pack.active ? false: true"
              :color="pack.active ? 'primary': 'grey'"
              :text-color="pack.active ? 'white' : 'grey'"
            >3</v-chip>บรรจุหีบห่อสินค้า
          </div>
        </v-flex>        
      </v-layout>-->
    </v-container>
    <v-container fluid v-else>
      <v-layout row wrap justify-space-between>
        <div>
          <div class="grey--text">พนักงาน</div>
          <div class="headline">{{ empCode}}</div>
        </div>
        <div>
          <div class="grey--text">ใบขาย</div>
          <div class="headline">{{ docNo }}</div>
          <div class="subheading grey--text">ที่อยู่จัดส่ง: {{ shipment_to }} {{ docAddress }}</div>
        </div>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <div class="headline">กล่อง {{activeParcelName}}</div>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            ref="item"
            label="ป้อนรหัสสินค้า"
            :append-icon="item.input ? 'send' : ''"
            outline
            single-line
            clearable
            :error-messages="item.errorMessage"
            :success-messages="item.successMessage"
            v-model="item.input"
            @click:append="itemEnterScan"
            @keyup.enter="itemEnterScan "
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <div>จำนวน {{activeParcelTotalItems}} รายการ</div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <div
                class="text-xs-center subheading"
                v-if="!activeParcelTotalItems"
              >ยังไม่ได้ทำรายการ</div>
              <v-list two-line>
                <v-list-tile class="mb-4" v-for="item in activeParcelItems" :key="item.code">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.code}} {{ item.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-layout row wrap>
                        <v-flex xs12 sm8 md6 lg4>
                          <v-text-field type="number" v-model="item.qty">
                            <div slot="append-outer">PCS</div>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div class="text-xs-right">
                      <v-btn color="error" small fab outline>
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </div>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 text-xs-right mt-3>
          <v-btn color="success" large @click="saveParcel">บันทึก</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showAddParcel" persistent max-width="600px">
      <v-card>
        <v-card-title>Add Parcel</v-card-title>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex xs12>
                <v-select
                  label="Parcel size"
                  v-model="newPacelSize"
                  :items="parcelSizes"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showAddParcel = false">Close</v-btn>
          <v-btn color="green darken-1" flat @click="addParcel">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="parcelDetail.dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <div class="title">สินค้ากล่อง {{ parcelDetail.name }}</div>
        </v-card-title>
        <v-card-text>
          <v-container py-0>
            <v-layout>
              <v-flex xs12 v-for="item in parcelDetail.items" :key="'dialog'+item.code">
                <span class="subheading pr-3">{{ item.name }}</span>
                <span class="body-1 green--text">{{ item.qty }} {{ item.unit }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="parcelDetail.dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="parcelDelete.dialog" max-width="320">
      <v-card>
        <v-card-title>
          <div class="title">ยืนยันการลบ</div>
        </v-card-title>
        <v-card-text>
          <v-container py-0>
            <v-layout>
              <v-flex xs12>
                <span class="subheading pr-3">ต้องการลบ กล่อง {{ parcelNameDelete }} ใช่หรือไม่?</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="parcelDelete.dialog = false">ปิด</v-btn>
          <v-btn flat color="error" @click="deleteParcel()">ใช่</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Util from "@/util";
import EmployeeService from "@/services/EmployeeService";
import InvoiceService from "@/services/InvoiceService";
import ProductService from "@/services/ProductService";
import PackShipService from "@/services/PackShipService";
export default {
  name: "initDoc",
  data: () => ({
    dialog: false, // edit confirm dialog
    addinvoicedialog: false,
    empCode: "",
    empName: "",
    docNo: "",
    docInfo: "",
    docAddress: "",
    shipment_to: "",
    shipment_telephone: "",
    doc_ref: [],
    parcels_remove : [],
    doc_ref_add: "",
    last_add_invoice: "",
    errorPickDialog: false,

    employee: {
      input: "",
      showAction: true,
      errorMessage: "",
      displayDisable: false,
      active: true
    },
    doc: {
      input: "",
      showAction: false,
      errorMessage: "",
      displayDisable: true,
      active: false
    },
    pack: {
      input: "",
      showAction: true,
      errorMessage: "",
      displayDisable: true,
      active: false
    },
    sumParcel: {
      count: null,
      errorMessage: ""
    },
    parcels: [],
    activeParcelIndex: -1,
    activeParcel: null,
    item: {
      input: "",
      errorMessage: "",
      successMessage: ""
    },
    invoiceItems: [
      {
        code: "001",
        name: "item 001",
        qty: 1,
        unit: "PCS"
      },
      {
        code: "002",
        name: "item 002",
        qty: 2,
        unit: "PCS"
      },
      {
        code: "003",
        name: "item 002",
        qty: 3,
        unit: "PCS"
      }
    ],
    showAddParcel: false,
    newPacelSize: "",
    parcelSizes: [
      { code: "01", name: "Size 1*2" },
      { code: "02", name: "Size 3*4" }
    ],
    parcelDetail: {
      dialog: false,
      name: "",
      items: []
    },
    parcelDelete: {
      dialog: false,
      id: ""
    },
    pdfDocGen: null
  }),
  computed: {
    activeParcelName() {
      return this.activeParcel ? this.activeParcel.name : "";
    },
    activeParcelTotalItems() {
      return this.activeParcel ? this.activeParcel.items.length : 0;
    },
    activeParcelItems() {
      return this.activeParcel ? this.activeParcel.items : [];
    },
    parcelTotalItemQty() {
      return this.parcels.reduce((sum, parcel) => {
        return (
          sum + parcel.items.reduce((sumItem, item) => sumItem + +item.qty, 0)
        );
      }, 0);
    },
    invoiceTotalItemQty() {
      return this.invoiceItems.reduce((sum, item) => sum + +item.qty, 0);
    },
    balanceTotalItemQty() {
      return this.invoiceTotalItemQty - this.parcelTotalItemQty;
    },
    balanceTotalItem() {
      return this.invoiceItems.reduce((sum, item) => {
        let findItem = this.parcels.find(parcel => {
          return parcel.items.find(parcelItem => parcelItem.code === item.code);
        });
        return findItem ? sum : ++sum;
      }, 0);
    },
    parcelNameDelete() {
      let parcel = this.parcels.find(
        parcel => parcel.id === this.parcelDelete.id
      );
      return parcel ? parcel.name : "";
    },
    doc_ref_list() {
      let doc_ref_str = this.doc_ref.join(",");
      return doc_ref_str;
    }
  },
  watch: {
    "employee.input"(val) {
      if (!val) {
        this.employee.errorMessage = "";
      }
    },
    "doc.input"(val) {
      if (!val) {
        this.doc.errorMessage = "";
      }
    },
    "item.input"(val, oldVal) {
      if (!val) {
        this.item.errorMessage = "";
      }

      if (!oldVal) {
        this.item.successMessage = "";
      }
    },
    "sumParcel.count"(val) {
      if (isNaN(val)) {
        this.sumParcel.errorMessage = "ข้อมูลผิดพลาด";
      } else {
        this.sumParcel.errorMessage = "";
      }
    }
  },
  filters: {
    itemTotalQty(items) {
      return items.reduce((sum, item) => sum + +item.qty, 0);
    }
  },
  created() {},
  mounted() {
    // this.$refs.employee.focus();
    this.empCode = "001";
    this.docNo = "INV0001";
    this.docInfo = "";
  },
  methods: {
    clearAll() {
      this.parcels = [];
      this.sumParcel.count = null;
      this.employee.input = "";

      this.employee.showAction = true;
      this.employee.active = true;

      //next to step 2
      this.doc.input = "";
      this.doc.active = false;
      this.doc.showAction = false;
      this.doc.displayDisable = true;

      this.pack.active = false;
      this.pack.showAction = false;
      this.pack.displayDisable = true;

      this.parcels_remove = [];
      this.doc_ref = [];
      this.doc_ref_add = "";
    },
    async employeeEnterScan() {
      //Step 1
      if (!this.employee.input) {
        return;
      }
      //check from service
      let foundEmp = await this.existEmployee(this.employee.input);
      if (!foundEmp) {
        this.employee.errorMessage = "employee_not_found";
        return;
      } else {
        this.employee.errorMessage = "";
      }

      //this.empCode = this.employee.input;
      this.employee.showAction = false;
      this.employee.active = false;

      //next to step 2
      this.doc.active = true;
      this.doc.showAction = true;
      this.doc.displayDisable = false;

      this.$nextTick(() => {
        this.$refs.doc.focus();
      });
    },
    async addInvoice() {

      let getInvoice = await this.searchInvoiceEnter(this.doc_ref_add);
      this.last_add_invoice = this.doc_ref_add;
      //console.log(getInvoice);
      if (getInvoice.parcel_count == 0) {
        // 
        this.doc_ref.push(this.doc_ref_add);        
      }
      else {
        this.addinvoicedialog = true;
      }

      // pass      
      this.doc_ref_add = "";
      
    },
    //
    // Doc Invoice Method
    //
    async docEnterScan() {
      //Step 2
      if (!this.doc.input) {
        return;
      }

      //console.log(this.doc.input);
      //check from service
      let foundInvoice = await this.existsInvoice(this.doc.input);
      if (!foundInvoice) {
        this.doc.errorMessage = "doc_not_found";
        return;
      } else {
        this.doc.errorMessage = "";
      }

      this.docNo = this.doc.input;
      this.doc.showAction = false;
      this.doc.active = false;

      //next to step 3
      this.pack.active = true;
      this.pack.showAction = true;
      this.pack.displayDisable = false;

      // init add parcel
      // this.addParcel();
      this.$nextTick(() => {
        this.$refs.sumParcel.focus();
      });
    },
    async itemEnterScan() {
      //Scan item
      if (!this.item.input) {
        return;
      }
      //check from service
      // if (!this.getItemInvoice(this.item.input)) {
      //   this.item.errorMessage = "item_not_found";
      //   return;
      // } else {
      //   this.item.errorMessage = "";
      // }

      let getItemInvoiceResponse = await this.scanProduct(this.item.input);

      if (getItemInvoiceResponse) {
        //console.log(getItemInvoiceResponse);
        this.item.errorMessage = "";
      } else {
        this.item.errorMessage = "item_not_found";
        return;
      }

      //add items
      let existItem = this.activeParcel.items.find(item => {
        return item.code == this.item.input;
      });

      if (existItem) {
        existItem.qty = existItem.qty + 1;
      } else {
        //let tmpIdx = this.activeParcel.items.length + 1;
        this.activeParcel.items.push({
          code: this.item.input,
          name: getItemInvoiceResponse.name,
          unit: getItemInvoiceResponse.unit_standard,
          qty: 1
        });
      }

      this.item.successMessage = `เพิ่มรายการ ${this.item.input}`;
      this.item.input = "";
    },
    showParcelDetail(parcelName, parcelItems) {
      this.parcelDetail.name = parcelName;
      this.parcelDetail.items = parcelItems;
      this.parcelDetail.dialog = true;
    },
    getItemInvoice(itemCode) {
      return this.invoiceItems.find(item => item.code === itemCode);
    },
    parcelItemTotalQty(itemCode) {
      return this.parcels.reduce((sum, parcel) => {
        let findItem = parcel.items.find(item => item.code === itemCode);
        return findItem ? sum + findItem.qty : sum;
      }, 0);
    },
    openAddParcel() {
      this.showAddParcel = true;
      this.newPacelSize = this.parcelSizes[0].code;
    },
    addParcel() {
      this.showAddParcel = false;

      let nextNumber =
        this.parcels.length > 0
          ? this.parcels[this.parcels.length - 1].no + 1
          : 1;
      let newParcelIndex = this.parcels.push({
        id: Util.GENID(),
        no: nextNumber,
        name: "" + nextNumber,
        size: this.newPacelSize,
        items: []
      });

      //go to new parcel
      this.clearScanParcel();
      this.enterParcel(newParcelIndex - 1);
    },
    clearScanParcel() {
      this.item.input = "";
      this.item.successMessage = "";
      this.item.errorMessage = "";
    },
    enterParcel(parcelKey) {
      this.activeParcelIndex = parcelKey;
      this.activeParcel =
        typeof this.parcels[parcelKey] === "undefined"
          ? null
          : JSON.parse(JSON.stringify(this.parcels[parcelKey]));

      this.clearScanParcel();
    },
    submitParcel() {
      if (!isNaN(this.sumParcel.count)) {
        this.parcels = [];

        for (let count = 0; count < this.sumParcel.count; count++) {
          let nextNumber =
            this.parcels.length > 0
              ? this.parcels[this.parcels.length - 1].no + 1
              : 1;

          this.parcels.push({
            id: Util.GENID(),
            no: nextNumber,
            name: "" + nextNumber,
            size: this.newPacelSize,
            items: [],
            ship_to: this.shipment_to,
            ship_address: this.docAddress,
            show_detail: false
          });
        }
      }
      this.clearScanParcel();
      // gen parcel and preview for print
    },
    handleParcelDelete(parcelID) {
      this.parcelDelete.id = parcelID;
      this.parcelDelete.dialog = true;
    },
    deleteParcel() {
      this.parcelDelete.dialog = false;
      if (!this.parcelDelete.id) {
        return;
      }

      this.parcels = this.parcels.filter(
        parcel => parcel.id !== this.parcelDelete.id
      );
      this.parcelDelete.dialog = false;
    },
    saveParcel() {
      this.parcels[this.activeParcelIndex].items = this.activeParcel.items;
      this.activeParcelIndex = -1;
      this.activeParcel = null;

      this.clearScanParcel();
      // console.log(this.getUsedItemTotalQty('001'))
    },
    async existEmployee(employeeCode) {
      let pass = false;

      await EmployeeService.getEmployee(employeeCode)
        .then(res => {
          if (res.success && res.employee.code != "") {
            //){
            pass = true;
            this.empCode = res.employee.code;
            this.empName = res.employee.name;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      return pass;
    },
    async searchInvoiceEnter(invoiceDocNo) {
      let invoice = null;
      await InvoiceService.getInvoice(invoiceDocNo)
        .then(res => {
          if (res.success) {
            //console.log(res);
            invoice = res.data;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      return invoice;
    },

    async existsInvoice(invoiceDocNo) {
      let pass = false;

      let invoice = await this.searchInvoiceEnter(invoiceDocNo);
      // console.log(invoice);
      if (invoice != null) {
        if (invoice.parcel_count == undefined || invoice.parcel_count == 0) {
          pass = true;
          //console.log(res);
          this.docInfo = invoice.header.data[0].cust_code;
          this.docAddress = invoice.dataShipment.data[0].transport_address;
          this.shipment_to = invoice.dataShipment.data[0].transport_name;
          this.shipment_telephone =
            invoice.dataShipment.data[0].transport_telephone;

            this.doc_ref = [];
            this.doc_ref.push(invoiceDocNo);
        } 
        else if (invoice.parcel_pick > 0) {
          this.errorPickDialog = true;
        }
        else {
          // edit mode
          this.dialog = true;
        }
      }

      return pass;
    },
    async confirmEditParcel() {
      this.dialog = false;
      let editParcel = await this.getEditParcel(this.doc.input);
      if (editParcel != null) {
        // load data

        this.doc.errorMessage = "";

        this.docNo = this.doc.input;
        this.doc.showAction = false;
        this.doc.active = false;

        //next to step 3
        this.pack.active = true;
        this.pack.showAction = true;
        this.pack.displayDisable = false;

        // Load Data to Screen
        this.docInfo = editParcel.parcel.parcels[0].cust_code;
        this.docAddress = editParcel.parcel.parcels[0].address;
        this.shipment_to = editParcel.parcel.parcels[0].cust_name;
        this.shipment_telephone =
          editParcel.parcel.parcels[0].telephone;

        this.sumParcel.count = editParcel.parcel.parcels.length
        // this.addParcel();
        this.parcels = [];
        this.parcels_remove = [];

        editParcel.parcel.parcels.forEach((parcel) => {

          this.parcels.push({
            id: parcel.parcel_guid,
            no: parcel.parcel_no,
            name: parcel.parcel_no,
            size: this.newPacelSize,
            items: [],
            ship_to: parcel.cust_name,
            ship_address: parcel.address,
            show_detail: false
          });
          
          this.parcels_remove.push(parcel.parcel_guid)

        });

        this.doc_ref = [];
        editParcel.parcel.doc_ref.forEach((ref) => {
          this.doc_ref.push(ref.ref_doc_no)
        });

        this.$nextTick(() => {
          this.$refs.sumParcel.focus();
        });
      }
    },
    confirmCencelEditParcel() {
      this.dialog = false;
      this.doc.input = "";

      this.$nextTick(() => {
        this.$refs.doc.focus();
      });
    },
    async getEditParcel(InvoiceNo) {
      // get all parcel and all doc_ref
      let loadParcelList = null;
      await PackShipService.loadParcel(InvoiceNo)
        .then(res => {
          if (res.success) {
            
            //console.log(res);
            loadParcelList = res;
            //this.empName = res.employee.name

            // let productData = {
            //   code: res.product.data[0].code,
            //   name: res.product.data[0].name,
            //   unit_standard: "PCS",
            //   unitlist: res.product.unit.data
            // };
            // result = productData;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      return loadParcelList;
    },
    async scanProduct(productCode) {
      let result = null;
      await ProductService.getProduct(productCode)
        .then(res => {
          if (res.success) {
            //){
            //console.log(res);

            //this.empName = res.employee.name

            let productData = {
              code: res.product.data[0].code,
              name: res.product.data[0].name,
              unit_standard: "PCS",
              unitlist: res.product.unit.data
            };
            result = productData;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      return result;
    },
    async savePackingParcel() {
      //
      let result = "";
      await PackShipService.addPackSHip(
        this.empCode,
        this.parcels,
        this.docNo,
        this.docInfo,
        this.docAddress,
        this.shipment_to,
        this.shipment_telephone,
        this.parcels_remove,
        this.doc_ref
      )
        .then(res => {
          //console.log(res);
          if (res.data.success) {
            return "";
          } else {
            result = res.data.message;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      return result;
    },
    async savePackingHandle() {
      let result = await this.savePackingParcel();
      //console.log(result);
      if (result == "") {
        // clear state
        this.parcelLabelPrint();
        this.clearAll();
      } else {
        // warning error
      }
    },
    parcelLabelPrint() {
      // buldContent
      let dataPrint = [];
      this.parcels.forEach(function(parcel, index, parcels) {
        //console.log(parcel);

        // dataPrint.push({
        //   text: parcel.id,
        //   fontSize: 7,
        //   alignment: "right",
        //   pageBreak: index > 0 ? "before" : "",
        //   margin: [0, 0, 0, 0]
        // });

        dataPrint.push({
          pageBreak: index > 0 ? "before" : "",
          columns: [
            {
              width: 130,
              text: "ส่ง",
              fontSize: 58,
              style: ["boldStyle"]
            },
            {
              width: "*",
              text: `จำนวน ${parcel.no}/${parcels.length}`,
              fontSize: 30,
              alignment: "center",
              style: ["boldStyle"]
            },
            {
              width: 140,
              qr: parcel.id,
              fit: "60",
              alignment: "right",
              margin: [0, 20, 0, 0],
            }
          ]
        });

        dataPrint.push({
          text: Util.thaiCharCutStr(parcel.ship_to, 25), // parcel.ship_to.substring(0, 25),
          noWrap: true,
          alignment: "center",
          fontSize: 40,
          style: ["boldStyle"],
          margin: [0, -20, 0, 0]
        });

        dataPrint.push({
          text: parcel.ship_address.substring(0, 90),
          fontSize: 30,
          bold: true
        });
      });

      var pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("@/print/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf"
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf"
        }
      };
      let docDefinition = {
        pageSize: {
          width: 280,
          height: 410
        },
        pageOrientation: "landscape",
        pageMargins: [10, 10, 10, 45],
        footer: {
          text: "จาก OR 099-009-3588",
          margin: [70, 0, 30, 0],
          fontSize: 24,
          alignment: "right",
          style: ["boldStyle"]
        },

        content: dataPrint,

        defaultStyle: {
          font: "THSarabunNew",
          fontSize: 14
        },
        styles: {
          boldStyle: {
            bold: true
          }
        }
      };
      this.pdfDocGen = pdfMake.createPdf(docDefinition);
      // this.pdfDocGen.getDataUrl(data => {
      //     console.log(data);
      //     this.src = data;
      // });

      this.pdfDocGen.print();
    },
    remove_doc_ref(index) {
      if (index > 0 || this.doc_ref.length > 1) {
        this.doc_ref.splice(index, 1)
        this.doc_ref = [...this.doc_ref]
      }
      
    }
  }
};
</script>

